module.exports = __webpack_public_path__ + "static/media/contact-header.35469191.JPG";